<template>
    <div
        class="w-[30%] text-center p-2.5 rounded-[4px] mt-4 hover:bg-primary-1 hover:text-white cursor-pointer group"
        :class="[ classCondition ? 'bg-primary-1 text-white' : 'bg-interactive-9 text-black', handleMarginLeft]"
        @click="emit('selectDonation', donation)"
    >
        <span class="uppercase text-xs" v-if="displayLabel">{{ donation.label }}</span>
        {{ '$' + amount }}
        <span
            class="ml-1 text-sm group-hover:text-white"
            :class="isDonationSelected ? 'text-white' : 'text-interactive-6'"
        >USD</span>
    </div>
</template>

<script setup>
import {computed} from "vue";
import {useDonationStore} from "@/store/useDonationStore";
import {storeToRefs} from "pinia";

const {selectedDonationFrequency} = storeToRefs(useDonationStore());

const emit = defineEmits(['selectDonation']);

const props = defineProps({
    donation: {
        type: Object,
        required: true,
    },
    displayLabel: {
        type: Boolean,
        default: false,
    },
    index: {
        type: Number,
        required: true,
    },
    selectedDonation: {
        type: Object,
        default: null,
    },
    isCustomDonation: {
        type: Boolean,
        default: false,
    },
    bodyWidth: {
        type: Number,
        default: 0,
    },
})

const handleMarginLeft = computed(() => {
    if(props.index === 0 || props.index % 3 === 0) {
        return 'ml-0';
    }

    if(props.bodyWidth <= 390) {
        return 'ml-2';
    }

    return 'ml-4';
});

const isDonationSelected = computed(() => {
    if(!props.selectedDonation) {
        return false;
    }
    return props.selectedDonation.id === props.donation.id && !props.isCustomDonation
});

const classCondition = computed(() => {
    if(!props.selectedDonation) {
        return false;
    }
    return !props.isCustomDonation && props.selectedDonation.id === props.donation.id
})

const amount = computed(() => {
    if(selectedDonationFrequency.value.id === 1) {
        return props.donation.amount;
    }

    //todo: revert the if below

    if(!Object.hasOwn(props.donation, 'amount_recurring')) {
        return props.donation.amount;
    }

    return props.donation.amount_recurring;
})
</script>